import Vue from 'vue';

import { stripNbsp } from '@/utils/html';

Vue.directive('normalize-html', {
  inserted (el, binding) {
    el.innerHTML = stripNbsp(binding.value);
  },
  update (el, binding) {
    if (binding.value !== binding.oldValue) {
      el.innerHTML = stripNbsp(binding.value);
    }
  },
  unbind (el) {
    el.innerHTML = '';
  },
});
